import React from 'react';
import SharedApplicationFormQuestions from '../applicationForm/sharedApplicationFormQuestions';

const AnsweredQuestion = (props) => {
    const {
        onAttachmentRequest,
        formData,
        question,
        questionAnswer,
        medicalExpertFees,
        _updateMedicalExpertFees,
        _handleTextInputChange,
        _handleSelectInputChange,
        _handleDateInputChange,
        _handleChangeOpponent,
        onDrop,
        opponent,
        multipleFilesAllowed,
        workSourceOptions,
        application,
        breachCausationCp,
        openDeleteAnswerModal,
        isPlain,
        opponentQuestions,
        isApplicationTab,
    } = props;

    return (
        <SharedApplicationFormQuestions
            {...props}
            question={question}
            isPlain={isPlain}
            value={questionAnswer}
            formData={formData}
            hasInlineElements={false}
            isAnswerEditModalOpen={true}
            dateHandler={_handleDateInputChange}
            textHandler={_handleTextInputChange}
            medicalFeesTableHandler={_updateMedicalExpertFees}
            medicalExpertFees={medicalExpertFees}
            textAreaRows={8}
            selectHandler={_handleSelectInputChange}
            onDrop={onDrop}
            workSourceOptions={workSourceOptions}
            multipleFilesAllowed={multipleFilesAllowed}
            onAttachmentRequest={onAttachmentRequest}
            application={application}
            breachCausationCp={breachCausationCp}
            openDeleteAnswerModal={openDeleteAnswerModal}
            opponentHandler={_handleChangeOpponent}
            opponents={[opponent]}
            opponentQuestions={opponentQuestions}
            isApplicationTab={isApplicationTab}
        />
    );
};

export default AnsweredQuestion;